var map = {
	"./beef-bun.jpg": 961,
	"./beef-noodle-soup.jpg": 888,
	"./beef-noodles.jpg": 4060,
	"./beef-rice-noodle-soup.jpg": 46,
	"./braised-pork-noodle-soup.jpg": 1179,
	"./braised-pork-noodles.jpg": 6850,
	"./broccoli-garlic-sauce.jpg": 5722,
	"./chicken-potstickers.jpg": 8838,
	"./cold-noodles.jpg": 3855,
	"./hot-oil-noodles.jpg": 6190,
	"./hot-sour-rice-noodles.jpg": 4596,
	"./lamb-bun.jpg": 7712,
	"./lamb-dumplings.jpg": 9630,
	"./lamb-haggis-soup.jpg": 7348,
	"./lamb-noodle-soup.jpg": 98,
	"./lamb-noodles.jpg": 8157,
	"./lamb-pao-mo.jpg": 4146,
	"./lamb-rice-noodle-soup.jpg": 503,
	"./lamb-soup.jpg": 365,
	"./lotus-root.jpg": 8249,
	"./marinated-pork-intestine.jpg": 2962,
	"./mouthwatering-chicken-noodles.jpg": 6522,
	"./pork-bun.jpg": 1746,
	"./pork-dumplings.jpg": 5723,
	"./pork-intestine-rice-noodle-soup.jpg": 6477,
	"./pork-wontons-chili-sauce.jpg": 9368,
	"./qishan-pork-noodle-soup.jpg": 4727,
	"./qishan-pork-noodles.jpg": 3149,
	"./sichuan-sliced-beef.jpg": 7982,
	"./three-flavor-dumplings.jpg": 359,
	"./tomato-egg-noodles.jpg": 8988,
	"./vegetable-noodle-soup.jpg": 9146,
	"./vegetable-noodles.jpg": 3106
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8822;